import { createContext } from 'react';

import { IWorkflowStepCompletionsResponse } from '@commenda/api/workflow-execution';

export interface ServiceRequestStepCompletionState {
  enabled: boolean;
  responses?: IWorkflowStepCompletionsResponse[];
  isLoading: boolean;
  error?: unknown;
}

export const ServiceRequestStepCompletionContext =
  createContext<ServiceRequestStepCompletionState>({
    enabled: false,
    isLoading: false,
  });
